const isProduction = (url) => !/:\/\/(qa|local|review)/.test(url);

export default isProduction;
